export default __webpack_public_path__ + "static/media/rejected.7e707745.svg";